import React, { useMemo } from "react";
import {
  type Icon,
  StorefrontIcon,
  ShoppingCartSimpleIcon,
  MartiniIcon,
  ForkKnifeIcon,
  CoffeeIcon,
  BabyIcon,
  BusIcon,
  TrainIcon,
  TrafficSignalIcon,
  TreeIcon,
  BarbellIcon,
  BrainIcon,
  PawPrintIcon,
  GasPumpIcon,
  HeartbeatIcon,
  PaletteIcon,
  ArmchairIcon,
  BackpackIcon,
  GraduationCapIcon,
  MapPinIcon,
} from "@phosphor-icons/react";
import type { POIs, Schools } from "@local-logic/client";

type POI = keyof POIs | keyof Schools;

export const icons: {
  [key in POI | "other"]: Icon;
} = {
  groceries: StorefrontIcon,
  groceries_specialized: StorefrontIcon,
  shopping: ShoppingCartSimpleIcon,
  nightlife: MartiniIcon,
  restaurants: ForkKnifeIcon,
  healthy_restaurants: ForkKnifeIcon,
  cafes: CoffeeIcon,
  daycares: BabyIcon,
  bus_stops: BusIcon,
  rapid_transit_stations: TrainIcon,
  train_stations: TrafficSignalIcon,
  parks: TreeIcon,
  fitness: BarbellIcon,
  sport_facilities: BarbellIcon,
  personal_care: BrainIcon,
  pet_care: PawPrintIcon,
  car_fueling_stations: GasPumpIcon,
  health_care: HeartbeatIcon,
  art_culture_science: PaletteIcon,
  home_improvement: ArmchairIcon,
  primary_schools: BackpackIcon,
  high_schools: GraduationCapIcon,
  other: MapPinIcon,
};

export const PoiIcon = ({
  poi,
  className,
}: {
  poi: POI;
  className?: string;
}) => {
  const Icon = useMemo(() => icons[poi], [poi]);

  return <Icon className={className} />;
};
